<template>
  <div :class="$style.deleteContentsAlert">
    <v-alert :value="true" type="warning">
      {{ isUserDelete ? lang.deleted_by_user : lang.deleted_by_admin }}
    </v-alert>
    <div class="mt-3">{{ lang.jump_to_service_top }}</div>
  </div>
</template>

<script>
export default {
  name: "vc-share-deleted-contents-alert",
  props: {
    isUserDelete: {
      type: Boolean,
      default: true
    },
    locationHref: {
      type: String,
      default: "/"
    },
    lang: {
      type: Object,
      default: () => {
        return {
          deleted_by_user: "このコンテンツは投稿者により削除されました",
          deleted_by_admin: "このコンテンツは運営により削除されました",
          jump_to_service_top: "5秒後にサービストップへ移動します"
        };
      }
    }
  },
  mounted: function() {
    const thisObj = this;
    setTimeout(function() {
      location.href = thisObj.locationHref;
    }, 5000);
  }
};
</script>

<style module>
.deleteContentsAlert {
  width: 100%;
  min-height: 450px;
}
</style>
